const VIDEO_EXTENSIONS = new Set(["mp4", "webm", "mov", "m4v", "ogg"]);

export function isVideoMediaUrl(url?: string | null): boolean {
  if (!url) {
    return false;
  }
  const clean = url.split("?")[0].split("#")[0];
  const ext = clean.split(".").pop()?.toLowerCase() || "";
  return VIDEO_EXTENSIONS.has(ext);
}

/** Poster/thumbnail URL for feed cards — never loads full video in the grid. */
export function getFeedPosterUrl(item: any): string {
  if (!item) {
    return "assets/images/blank.png";
  }

  const poster =
    item.videoThumbNailUrl ||
    item.VideoThumbNailUrl ||
    item.videoThumbnailUrl ||
    item.posterUrl ||
    "";
  const mediaUrl = item.url || item.Url || "";

  if (item.showImage !== false && mediaUrl && !isVideoMediaUrl(mediaUrl)) {
    return mediaUrl;
  }
  if (poster) {
    return poster;
  }
  if (mediaUrl && !isVideoMediaUrl(mediaUrl)) {
    return mediaUrl;
  }
  return "assets/images/blank.png";
}

export function trackFeedItem(index: number, item: any): string {
  return (
    item?.rowKey ||
    item?.Id ||
    item?.id ||
    item?.uniqueId ||
    String(index)
  );
}
